module.exports = __webpack_public_path__ + "static/media/Nokia 230 White.4ef75a2b.png";